import take from "./take.js";
var take1 = take(1);
export default take1;